import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ReviewComponent} from './review/review.component';
import {SharedModule} from "../shared/shared.module";
import {MaterialModule} from "../shared/material.module";
import {StatusTrackerModule} from "../status-tracker/status-tracker.module";
import {FlexLayoutModule} from "@angular/flex-layout";
import {SignupModule} from "../signup/signup.module";
import {TermsAndConditionsComponent} from "./terms-and-conditions/terms-and-conditions.component";
import { HttpClientModule } from '@angular/common/http'
import { ViewDisclosuresComponent } from './view-disclosures/view-disclosures.component';
import {MatDialogModule} from "@angular/material/dialog";

@NgModule({
  declarations: [
    ReviewComponent,
    TermsAndConditionsComponent,
    ViewDisclosuresComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule,
    StatusTrackerModule,
    FlexLayoutModule,
    SignupModule,
    HttpClientModule,
    MatDialogModule
  ],
    exports: [
        ReviewComponent,
        TermsAndConditionsComponent
    ],
  providers: []
})
export class ReviewModule {
}
